module.exports = __webpack_public_path__ + "static/Virtual-Care-HIPAA-Compliance-min-96806e525d24ee26a808d16a978a5cd4.png";